declare namespace $ {

	type $mol_button_minor__title_bog_vmap_app_history_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_history_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_history_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['undoable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_vmap_app_history_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['undo'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_vmap_app_history_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_history_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_history_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['redoable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_vmap_app_history_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['redo'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_vmap_app_history_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_history_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_history_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['editable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_vmap_app_history_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['snap_take'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_status__status_bog_vmap_app_history_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['note'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_list__rows_bog_vmap_app_history_14 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['snap_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $bog_vmap_app_history_snap__moment_bog_vmap_app_history_15 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['snap_moment'] >
		,
		ReturnType< $bog_vmap_app_history_snap['moment'] >
	>
	type $bog_vmap_app_history_snap__author_bog_vmap_app_history_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['snap_author'] >
		,
		ReturnType< $bog_vmap_app_history_snap['author'] >
	>
	type $bog_vmap_app_history_snap__change_bog_vmap_app_history_17 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['snap_change'] >
		,
		ReturnType< $bog_vmap_app_history_snap['change'] >
	>
	type $bog_vmap_app_history_snap__preview_bog_vmap_app_history_18 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['snap_preview'] >
		,
		ReturnType< $bog_vmap_app_history_snap['preview'] >
	>
	type $bog_vmap_app_history_snap__editable_bog_vmap_app_history_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['editable'] >
		,
		ReturnType< $bog_vmap_app_history_snap['editable'] >
	>
	type $bog_vmap_app_history_snap__back_bog_vmap_app_history_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history['snap_back'] >
		,
		ReturnType< $bog_vmap_app_history_snap['back'] >
	>
	export class $bog_vmap_app_history extends $mol_page {
		undoable( ): boolean
		undo( next?: any ): any
		Undo( ): $mol_button_minor
		redoable( ): boolean
		redo( next?: any ): any
		Redo( ): $mol_button_minor
		snap_take( next?: any ): any
		Take( ): $mol_button_minor
		snap_rows( ): readonly(any)[]
		snap_moment( id: any): string
		snap_author( id: any): string
		snap_change( id: any): string
		snap_preview( id: any): string
		snap_back( id: any, next?: any ): any
		store( ): $bog_vmap_app_store
		state( next?: Record<string, any> ): Record<string, any>
		live( ): readonly(any)[]
		press( next?: any ): any
		editable( ): boolean
		note( next?: string ): string
		title( ): string
		tools( ): readonly(any)[]
		Note( ): $mol_status
		List( ): $mol_list
		Snap_row( id: any): $bog_vmap_app_history_snap
	}
	
}

//# sourceMappingURL=history.view.tree.d.ts.map